import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { GeneralService } from 'src/app/services/general.service';
import * as globalUrls from 'src/app/services/globalVariables';
import { MatTableDataSource } from '@angular/material/table';

import { log } from 'console';
export interface tableEmbauche {
  IDComplete: string;
  Sexe: string;
  Date_Naissance: string;
  Num_CIDN: string;
  NUM_CNSS: string;
  Adresse: string;
  Date_Recrutement: string;
  StatutProf: string;
  Salaire: string;
}
const ListEmbaucheDayMat: tableEmbauche[] = [];
@Component({
  selector: 'app-nouveaux-employes',
  templateUrl: './nouveaux-employes.component.html',
  styleUrls: ['./nouveaux-employes.component.scss'],
})
export class NouveauxEmployesComponent implements OnInit {
  displayedColumns: string[] = [
    'IDComplete',
    'Sexe',
    'Date_Naissance',
    'Num_CIDN',
    'NUM_CNSS',
    'Adresse',
    'Date_Recrutement',
    'StatutProf',
    'Salaire',
    'Action',
  ];
  dataSource: MatTableDataSource<tableEmbauche>;
  @ViewChild('frmNewEmb', { static: false }) frmNewEmb;
  @ViewChild('frmDelete', { static: false }) frmDelete;
  url = globalUrls.urlPerso;
  PostEmp;
  today;
  StyleSpanSexe: any;
  StyleSpanNais: any;
  StyleSpanCin: any;
  StyleSpanCnss: any;
  StyleSpanAdr: any;
  StyleSpanRec: any;
  StyleSpanStat: any;
  StyleSpanMont: any;
  StyleSpanId: any;
  Apresle = null;
  ville = null;
  previewMode = true;
  id = null;
  cnss = null;
  cin = null;
  sexe = null;
  montant = null;
  nat = null;
  stat = null;
  adresse = null;
  datenais: any;
  daterec: any;
  quliteDe = null;
  numTel = null;
  nom = null;
  prenom = null;
  fonction = null;
  empHab = null;
  qualprof = null;
  nomEtPrenomSoussigne = null;
  nomEtPrenomSoussigne1 = null;
  codePost = null;
  adresseEmployeur_1 = null;
  numCNSSEmployeur = null;
  raisonSocial = null;
  ListEmbaucheDay = [];
  ListSoc;
  Daterec;
  Apreslel = null;
  Pagediff = 790;
  TabTop = ['384px', '445px', '506px', '567px', '628px'];
  dsPost;
  DateRecSelect;
  DateRecSelectPost;
  DateRecSelectPost2;
  listFonction;
  fields = {
    Adresse: null,
    Cnam_ID: null,
    CodePostal: null,
    DateCreate: null,
    NOM: null,
    NomRec: null,
    NumAffCNSS: null,
    PosteRec: null,
    Tel: null,
    Ville: null,
  };
  sex = [
    { key: 1, value: 'Homme' },
    { key: 2, value: 'Femme' },
  ];
  refreshing = false;
  api = 'https://backend-uniges.pmc.tn/api/';
  //,"1172px","1233px","1294px","1355px","1416"
  constructor(
    public generalService: GeneralService,
    private datePipe: DatePipe
  ) {
    // this.generalService.getDS('avtPerso', '0406').subscribe(res => {
    //   console.log(res);
    // })
    this.generalService.getDS('CNAM').subscribe((res) => {
      this.PostEmp = res;
      console.log(res);
    });
    this.generalService.rechercheTable2('API_Soc').subscribe((res) => {
      //console.log(res);
      this.ListSoc = res;
    });
    this.generalService.getDS('Perso').subscribe((data) => {
      this.dsPost = data;
      console.log(data);
    });
    // for (let i = 0; i <= 29; i++) {
    //   let n = {
    //     Adresse: "14/14/1414", Cnam_ID: null, Date_Naissance: "14/02/1415",
    //     Date_Recrutement: "14/02/1415", ID: null
    //     , IDComplete: "14/14/1414", NUM_CNSS: "14/14/1414", Num_CIDN: "14/14/1414",
    //     Salaire: "14/14/1414", Sexe: "F", StatutProf: "14/14/1414"
    //   }
    //   this.ListEmbaucheDay.push(n)
    // }
    this.getTypeFonction();
    this.initialise();
    this.styleElment();
  }

  datePostDec() {
    this.DateRecSelectPost = (<HTMLInputElement>(
      document.getElementById('DateRecSelectPost')
    )).value;
    console.log(this.DateRecSelectPost);
  }
  reloadTable() {
    this.dataSource = new MatTableDataSource(this.ListEmbaucheDay);
  }
  dateLe() {
    this.Apresle = this.datePipe.transform(this.Apreslel, 'dd/MM/YYYY');
  }
  idSoc;
  selectSoc(soc) {
    console.log(soc);
    this.ListSoc.forEach((element) => {
      if (element.SOC_RS == soc) {
        this.numCNSSEmployeur = element.SOC_AFFCNSS;
        this.idSoc = element.SOC_ID;
        this.raisonSocial = element.SOC_RS;
        this.codePost = element.SOC_CodePostal;
        this.numTel = element.SOC_NumTel;
        this.adresseEmployeur_1 = element.SOC_Adresse;
      }
    });
  }
  idSocSel;
  lastIdSoc;
  selectSocEmp(soc) {
    console.log(soc);
    this.lastIdSoc = soc;
  }
  ngOnInit(): void {
    this.initialise();
    this.initialiseDialogue();
  }
  initialise() {
    this.StyleSpanId = {
      position: 'absolute',
      top: '384px',
      left: '40px',
    };
    this.StyleSpanSexe = {
      position: 'absolute',
      top: '384px',
      left: '265px',
    };
    this.StyleSpanNais = {
      position: 'absolute',
      top: '384px',
      left: '300px',
    };
    this.StyleSpanCin = {
      position: 'absolute',
      top: '384px',
      left: '394px',
    };
    this.StyleSpanCnss = {
      position: 'absolute',
      top: '384px',
      left: '494px',
    };
    this.StyleSpanAdr = {
      position: 'absolute',
      top: '384px',
      left: '596px',
    };
    this.StyleSpanRec = {
      position: 'absolute',
      top: '384px',
      left: '798px',
    };
    this.StyleSpanStat = {
      position: 'absolute',
      top: '384px',
      left: '887px',
    };
    this.StyleSpanMont = {
      position: 'absolute',
      top: '384px',
      left: '983px',
    };
  }
  selectFonc(f) {
    this.fonction = f;
  }
  DialogeOpenModif = false;
  openDialogAdd() {
    this.DialogeOpenModif = false;
    this.generalService.dialog.open(this.frmNewEmb, {
      width: '120vw',
      disableClose: true,
    });
    this.generalService.dialog.afterAllClosed.subscribe(() => {
      //this.initialiseDialogue()
    });
  }
  splitBy(arr, size) {
    return arr.reduce(
      (acc, e, i) => (
        i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc
      ),
      []
    );
  }
  initialiseDialogue() {
    try {
      this.id = null;
      this.cnss = null;
      this.cin = null;
      this.sexe = null;
      this.idSocSel = null;
      this.montant = null;
      this.stat = null;
      this.adresse = null;
      this.datenais = null;
      this.daterec = null;
      this.nom = null;
      this.prenom = null;
      this.fonction = null;
      this.nat = null;
      this.empHab = null;
      (<HTMLInputElement>document.getElementById('naissance')).value = null;
      (<HTMLInputElement>document.getElementById('recrutement')).value = null;
      (<HTMLInputElement>document.getElementById('DateRecSelectPost')).value =
        null;
    } catch (error) {}
  }

  fieldsBeforeAdd() {
    this.fields.Adresse = this.adresseEmployeur_1;
    this.fields.Cnam_ID = null;
    this.fields.CodePostal = this.codePost;
    this.fields.DateCreate = this.Apresle;
    this.fields.NOM = this.raisonSocial;
    this.fields.NomRec = this.nomEtPrenomSoussigne;
    this.fields.NumAffCNSS = this.numCNSSEmployeur;
    this.fields.PosteRec = this.quliteDe;
    this.fields.Tel = this.numTel;
    this.fields.Ville = this.ville;
  }
  nompSous;
  persoSousSelected;
  blurPersoSS(id) {
    this.generalService.getDS('Perso', id).subscribe((res) => {
      this.persoSousSelected = res;
      this.nomEtPrenomSoussigne1 =
        this.persoSousSelected.perso[0].Perso_Nom +
        ' ' +
        this.persoSousSelected.perso[0].Perso_Prenom;
      this.quliteDe = this.persoSousSelected.perso[0].Perso_Emploi;
    });
  }

  toModif;
  dateRec;

  modifer(par: any) {
    console.log(par);
    this.generalService.getDS('Perso', par.Matrucule).subscribe((res) => {
      this.toModif = res;
      console.log(this.toModif);
      this.DialogeOpenModif = true;
      this.generalService.dialog.open(this.frmNewEmb, {
        width: '70vw',
        disableClose: true,
      });
      (<HTMLInputElement>document.getElementById('naissance')).value =
        this.datePipe.transform(
          this.toModif.perso[0].Perso_DateNaissance,
          'dd/MM/YYYY'
        );
      (<HTMLInputElement>document.getElementById('recrutement')).value =
        this.datePipe.transform(
          this.toModif.perso[0].XdateDeclaration,
          'dd/MM/YYYY'
        );
      (<HTMLInputElement>document.getElementById('DateRecSelectPost')).value =
        this.datePipe.transform(
          this.toModif.perso[0].Perso_DateDeb,
          'dd/MM/YYYY'
        );
      this.id = this.toModif.perso[0].XID_Complete;
      this.cnss = this.toModif.perso[0].Perso_N_CNSS;
      this.cin = this.toModif.perso[0].Perso_CIN;
      this.sexe = this.toModif.perso[0].Perso_Sex;
      //this.montant = this.toModif.perso[0].Perso_Salaire;
      this.stat = this.toModif.perso[0].Perso_Status;
      this.adresse = this.toModif.perso[0].Perso_Adresse;
      this.nom = this.toModif.perso[0].Perso_Nom;
      this.prenom = this.toModif.perso[0].Perso_Prenom;
      this.empHab = this.toModif.perso[0].Perso_Emploi;
      this.qualprof = this.toModif.perso[0].XqualProfessionel;
      this.nat = this.toModif.perso[0].Perso_Nationalite;
      //(<HTMLInputElement>document.getElementById("naissance")).value = this.datePipe.transform(par.XDateCreate, 'dd/MM/YYYY');
      this.nomJfille = this.toModif.perso[0].XNomJF;
      this.prenomPere = this.toModif.perso[0].XPrenomPere;
      this.lieuNais = this.toModif.perso[0].XLieuNaissance;
      this.idSocSel = parseInt(this.toModif.perso[0].XSoc_Code);
      this.lastIdSoc = this.toModif.perso[0].XSoc_Code;
      console.log(this.toModif.perso[0].XPersoSig);
      console.log(typeof this.toModif.perso[0].XPersoSig);
      if (this.toModif.perso[0].XPersoSig) {
        if (parseInt(this.toModif.perso[0].XPersoSig) == 1) this.peroSig = '1';
        else this.peroSig = '0';
      }

      this.generalService.dialog.afterAllClosed.subscribe(() => {
        this.ngOnInit();
      });
    });
    // this.generalService.delete('0399','avtPerso').subscribe(res => {
    //   console.log(res);
    // })
  }

  toDelete;
  supprimer() {
    this.ListEmbaucheDay.forEach((element, i) => {
      if (element == this.toDelete) {
        this.ListEmbaucheDay.splice(i, 1);
      }
    });
    this.generalService
      .delete(this.toDelete.Matrucule, 'Perso')
      .subscribe((res) => {
        console.log(res);
      });
    this.styleElment();
  }

  selectSexe(s: any) {
    this.sexe = s;
    console.log(s);
  }

  close() {
    this.generalService.dialog.afterAllClosed.subscribe(() => {});
  }

  openDialogue(par: any) {
    this.generalService.dialog.open(this.frmDelete, {
      width: '20vw',
      disableClose: true,
    });
    this.toDelete = par;
  }
  dateCreate = null;
  nomJfille = null;
  prenomPere = null;
  lieuNais = null;
  peroSig = null;
  add() {
    if (!this.DialogeOpenModif) {
      this.dateCreate = new Date();
      this.datenais = (<HTMLInputElement>(
        document.getElementById('naissance')
      )).value;
      let parts = this.datenais.split('/');
      let datenais = new Date(
        Number(parts[0]),
        Number(parts[1]) - 1,
        Number(parts[2])
      );
      console.log(datenais);

      this.datenais = this.datePipe.transform(datenais, 'dd/MM/YYYY');
      this.daterec = (<HTMLInputElement>(
        document.getElementById('recrutement')
      )).value;
      if (
        this.id &&
        this.sexe &&
        this.cin &&
        this.adresse &&
        this.daterec &&
        this.datenais &&
        this.stat &&
        this.lastIdSoc &&
        this.nom &&
        this.prenom &&
        this.peroSig
      ) {
        var newEmbauche = {
          IDComplete: this.id,
          NUM_CNSS: this.cnss,
          Num_CIDN: this.cin,
          Sexe: this.sexe,
          //Salaire: this.montant,
          Nationalite: this.nat,
          Adresse: this.adresse,
          StatutProf: this.stat,
          Date_Naissance: this.datenais,
          Date_Recrutement: this.daterec,
          Nom: this.nom,
          Prenom: this.prenom,
          Emploi: this.empHab,
          //Fonction: this.fonction,
          DateDec: this.DateRecSelectPost,
        };
        // post perso
        var postds = this.dsPost;
        postds.perso[0].Perso_DateNaissance = this.datenais;
        postds.perso[0].Perso_Sex = this.sexe;
        postds.perso[0].Perso_Status = this.stat;
        postds.perso[0].Perso_Adresse = this.adresse;
        //postds.perso[0].Perso_Salaire = this.montant
        postds.perso[0].Perso_CIN = this.cin;
        postds.perso[0].Perso_DateDeb = this.daterec;
        postds.perso[0].Perso_N_CNSS = this.cnss;
        postds.perso[0].Perso_Nom = this.nom;
        postds.perso[0].Perso_Prenom = this.prenom;
        postds.perso[0].XdateDeclaration = this.DateRecSelectPost;
        postds.perso[0].XID_Complete = this.id;
        postds.perso[0].Perso_Emploi = this.empHab;
        postds.perso[0].XqualProfessionel = this.qualprof;
        postds.perso[0].Perso_Nationalite = this.nat;
        postds.perso[0].XDateCreate = this.datePipe.transform(
          this.dateCreate,
          'dd/MM/YYYY'
        );
        postds.perso[0].XNomJF = this.nomJfille;
        postds.perso[0].XPersoSig = this.peroSig;
        postds.perso[0].XPrenomPere = this.prenomPere;
        postds.perso[0].XLieuNaissance = this.lieuNais;
        //postds.perso[0].Perso_Fonction = this.fonction
        postds.perso[0].XSoc_Code = this.lastIdSoc;
        console.log(postds);
        this.generalService
          .enregisterTable(
            this.generalService.supprimerTableVideAction(
              postds,
              ['PersoComp'],
              'Perso_Matricule'
            )
          )
          .subscribe((res) => {
            console.log(res);
            this.ListEmbaucheDay.push(newEmbauche);
            //this.initialiseDialogue();
            this.generalService.dialog.closeAll();
            this.generalService.dialogSuccess('Ajouter', true);
          });
      } else this.generalService.dialogSuccess('Remplir les champs', false);
      this.styleElment();
    }
    //Modiifer Embauche
    else {
      this.toModif.perso[0].Perso_DateNaissance = this.datePipe.transform(
        (<HTMLInputElement>document.getElementById('naissance')).value,
        'dd/MM/YYYY'
      );
      this.toModif.perso[0].Perso_DateDeb = this.datePipe.transform(
        (<HTMLInputElement>document.getElementById('recrutement')).value,
        'dd/MM/YYYY'
      );
      this.toModif.perso[0].XdateDeclaration = this.datePipe.transform(
        (<HTMLInputElement>document.getElementById('DateRecSelectPost')).value,
        'dd/MM/YYYY'
      );
      this.toModif.perso[0].XID_Complete = this.id;
      this.toModif.perso[0].Perso_N_CNSS = this.cnss;
      this.toModif.perso[0].Perso_CIN = this.cin;
      this.toModif.perso[0].Perso_Sex = this.sexe;
      this.toModif.perso[0].Perso_Status = this.stat;
      this.toModif.perso[0].Perso_Adresse = this.adresse;
      this.toModif.perso[0].Perso_Nom = this.nom;
      this.toModif.perso[0].Perso_Prenom = this.prenom;
      this.toModif.perso[0].Perso_Emploi = this.empHab;
      this.toModif.perso[0].XqualProfessionel = this.qualprof;
      this.toModif.perso[0].Perso_Nationalite = this.nat;
      //this.toModif.perso[0].XDateCreate = this.datePipe.transform(this.dateCreate, 'dd/MM/YYYY')
      console.log(this.nomJfille);

      this.toModif.perso[0].XNomJF = this.nomJfille;
      this.toModif.perso[0].XPrenomPere = this.prenomPere;
      this.toModif.perso[0].XLieuNaissance = this.lieuNais;
      this.toModif.perso[0].XPersoSig = this.peroSig;
      this.toModif.perso[0].XSoc_Code = this.lastIdSoc;
      this.generalService.postDs(this.toModif).subscribe(
        (res) => {
          console.log(res);
          this.generalService.dialogSuccess('Enregistrer avec succée', true);
        },
        (error) => {
          this.generalService.dialogSuccess('Non Enregistrer', false);
        }
      );
      // })
    }
  }
  clear() {
    this.datenais = null;
    this.sexe = null;
    this.stat = null;
    this.adresse = null;
    //postds.perso[0].Perso_Salaire = this.montant
    this.cin = null;
    this.daterec = null;
    this.cnss = null;
    this.nom = null;
    this.prenom = null;
    this.DateRecSelectPost = null;
    this.id = null;
    this.empHab = null;
    this.qualprof = null;
    this.nat = null;
    this.dateCreate = null;
    this.nomJfille = null;
    this.peroSig = null;
    this.prenomPere = null;
    this.lieuNais = null;
    //postds.perso[0].Perso_Fonction = this.fonction
    this.lastIdSoc = null;
  }
  selectRespo(event) {
    console.log(event);
    this.peroSig = event.value;
  }
  refreshList() {
    // ? toggle vsibility so the ui refreshes
    this.refreshing = true;
    setTimeout(() => {
      this.refreshing = false;
    }, 10);
  }
  getTypeFonction() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COL06')
      .subscribe((data) => {
        this.listFonction = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
      });
  }
  //AfterDaySelect
  dateRecChangeGetByDay() {
    let daEmb;
    let ListDayEmb;
    daEmb = this.datePipe.transform(this.DateRecSelect, 'dd/MM/YYYY');
    this.generalService
      .rechercheTable('API_PersoCNAM', daEmb + ',' + this.idSoc)
      .subscribe((res) => {
        ListDayEmb = res;
        this.ListEmbaucheDay = [];
        ListDayEmb.forEach((element) => {
          var newEmbauche = {
            IDComplete: element.XID_Complete,
            NUM_CNSS: element.Perso_N_CNSS,
            Num_CIDN: element.Perso_CIN,
            Sexe: this.changeSexe(element.Perso_Sex),
            //Salaire: element.Perso_Salaire,
            Adresse: element.Perso_Adresse,
            StatutProf: element.Perso_Status,
            Date_Naissance: this.datePipe.transform(
              element.Perso_DateNaissance,
              'dd/MM/YYYY'
            ),
            Date_Recrutement: this.datePipe.transform(
              element.Perso_DateDeb,
              'dd/MM/YYYY'
            ),
            Matrucule: element.Perso_Matricule,
            Nom: element.Perso_Nom,
            Prenom: element.Perso_Prenom,
            //Fonction: element.Perso_Fonction,
            DateDec: this.datePipe.transform(element.depuis, 'dd/MM/YYYY'),
          };
          this.ListEmbaucheDay.push(newEmbauche);
          this.styleElment();
        });
        this.reloadTable();
        console.log(this.ListEmbaucheDay);
      });
  }

  titelFunction(val) {
    this.listFonction.forEach((element) => {
      if (element.DiverSys_Index === val) {
        return element.DiverSys_Titre;
      }
    });
  }
  changeSexe(val) {
    if (val === 1) return 'Homme';
    else if (val === 2) return 'Femme';
    else return 'Non Déclaré';
  }
  changeSexePutAdd(val) {
    if (val === 'Homme') return 1;
    else if (val === 'Femme') return 2;
    else return 0;
  }

  styleElment() {
    var ln = Math.ceil(this.ListEmbaucheDay.length / 5);
    if (ln > 1) {
      for (let i = 1; i <= ln; i++) {
        let t = [];
        let posTop = 384 + this.Pagediff * i;
        t.push(posTop + 'px');
        for (let x = 1; x <= 4; x++) {
          posTop += 63;
          t.push(posTop + 'px');
        }
        t.forEach((element) => {
          this.TabTop.push(element);
        });
      }
    }
    this.ListEmbaucheDay.forEach((element, i) => {
      this.StyleSpanId.top = this.TabTop[i];
      element.StyleSpanId = { ...this.StyleSpanId };
      this.StyleSpanSexe.top = this.TabTop[i];
      element.StyleSpanSexe = { ...this.StyleSpanSexe };
      this.StyleSpanNais.top = this.TabTop[i];
      element.StyleSpanNais = { ...this.StyleSpanNais };
      this.StyleSpanCin.top = this.TabTop[i];
      element.StyleSpanCin = { ...this.StyleSpanCin };
      this.StyleSpanCnss.top = this.TabTop[i];
      element.StyleSpanCnss = { ...this.StyleSpanCnss };
      this.StyleSpanCnss.top = this.TabTop[i];
      element.StyleSpanCnss = { ...this.StyleSpanCnss };
      this.StyleSpanAdr.top = this.TabTop[i];
      element.StyleSpanAdr = { ...this.StyleSpanAdr };
      this.StyleSpanRec.top = this.TabTop[i];
      element.StyleSpanRec = { ...this.StyleSpanRec };
      this.StyleSpanStat.top = this.TabTop[i];
      element.StyleSpanStat = { ...this.StyleSpanStat };
      this.StyleSpanMont.top = this.TabTop[i];
      element.StyleSpanMont = { ...this.StyleSpanMont };
    });
    this.reloadTable();
  }
  // imprimer2() {
  //   if (this.ListEmbaucheDay[0])
  //     this.generalService.printContents("declarationNouveauEmp")
  //   else
  //     this.generalService.dialogSuccess(
  //       'Ajouter des employées',
  //       false
  //     );
  // }
  imprimer2() {
    if (this.ListEmbaucheDay[0])
      this.generalService.printContentsTest(
        'declarationNouveauEmp',
        '../../assets/print/dec-nouv-rec.jpg'
      );
    else this.generalService.dialogSuccess('Ajouter des employées', false);
  }
}
